<script setup>
import { computed } from 'vue';
// Import HeroIcons (or Lucide which comes with shadcn)
import {
  ChatBubbleLeftRightIcon,
  HandRaisedIcon,
  ShieldCheckIcon,
  InformationCircleIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon
} from '@heroicons/vue/24/outline';

const props = defineProps({
  name: { type: String, required: true },
  pack: { type: String, default: 'heroicons-outline' },
});

// Map string names to components
const iconMap = {
  'hand-waving': HandRaisedIcon,
  'shield-check': ShieldCheckIcon,
  'info': InformationCircleIcon,
  'chat': ChatBubbleLeftRightIcon,
  'check': CheckCircleIcon,
  'warning': ExclamationTriangleIcon,
  // Add more as needed...
};

const iconComponent = computed(() => iconMap[props.name] || InformationCircleIcon);
</script>

<template>
  <component :is="iconComponent" class="h-5 w-5" />
</template>
